import React, { useContext } from 'react';

const RouterContext = React.createContext();

const RouterProvider = ({ Link, NavLink, useLocation, children }) => {
  return <RouterContext.Provider value={{ Link, NavLink, useLocation }}>{children}</RouterContext.Provider>;
};

const useRouter = () => useContext(RouterContext);

export { useRouter, RouterProvider };
